(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var viewports = document.querySelectorAll('[data-marquee-viewport]');
  if (!viewports.length) return;

  Array.prototype.forEach.call(viewports, setup);

  function setup(viewport) {
    var track = viewport.querySelector('[data-marquee-track]');
    if (!track) return;

    var speed = parseFloat(viewport.getAttribute('data-marquee-speed')) || 40; // px per second
    var items = track.querySelectorAll('.p-marquee__item, .p-features-marquee__card');
    if (items.length < 2) return;

    var oneSetWidth = 0;
    var x = 0;
    var lastTs = null;
    var paused = false;
    var visible = true;
    var rafId = null;

    function measure() {
      // Sum width of one logical set = total width / copy count.
      // We assume Liquid renders 4 copies (i in 1..4). Compute using last item offset.
      var total = track.scrollWidth;
      // Find a stable boundary: assume even copy count; use total / 4 as one set
      // Fall back to total / 3 if needed.
      var copies = parseInt(viewport.getAttribute('data-marquee-copies'), 10) || 4;
      oneSetWidth = total / copies;
      // Reset starting position to a teleport-safe middle copy (set 2 start)
      if (x === 0 || Math.abs(x) >= oneSetWidth * (copies - 1)) {
        x = -oneSetWidth;
        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      }
    }

    function tick(ts) {
      if (lastTs == null) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      if (!paused && visible) {
        x -= speed * dt;
        // Teleport when crossing boundary so loop is invisible
        if (x <= -oneSetWidth * 2) {
          x += oneSetWidth;
        }
        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId != null) return;
      lastTs = null;
      rafId = requestAnimationFrame(tick);
    }
    function stop() {
      if (rafId != null) cancelAnimationFrame(rafId);
      rafId = null;
    }

    function onResize() {
      // Re-measure but keep relative position
      var copies = parseInt(viewport.getAttribute('data-marquee-copies'), 10) || 4;
      var total = track.scrollWidth;
      var newSet = total / copies;
      if (oneSetWidth > 0) {
        x = (x / oneSetWidth) * newSet;
      }
      oneSetWidth = newSet;
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    // Pause on hover (PC)
    viewport.addEventListener('pointerenter', function () { paused = true; });
    viewport.addEventListener('pointerleave', function () { paused = false; });

    // Pause when offscreen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { visible = entry.isIntersecting; });
      }, { threshold: 0 });
      io.observe(viewport);
    }

    // Re-measure only on width changes (orientation, resize)
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        onResize();
      }
    }, { passive: true });

    function init() {
      measure();
      if (!prefersReducedMotion) start();
    }

    // Wait for first image to load to ensure scrollWidth is accurate
    var firstImg = items[0].querySelector('img');
    if (!firstImg || firstImg.complete) {
      init();
    } else {
      firstImg.addEventListener('load', init, { once: true });
      firstImg.addEventListener('error', init, { once: true });
      window.addEventListener('load', init, { once: true });
    }
  }
})();
